import {useState, type FormEvent} from 'react';
import {AwButton, AwField} from '@ascension-tracker/ascension-ui';

export function QuickAddTask({onAdd, placeholder = 'Add task…'}: {onAdd: (title: string) => Promise<unknown>; placeholder?: string}) {
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);
  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const title = value.trim();
    if (!title || busy) return;
    setBusy(true);
    try { await onAdd(title); setValue(''); } finally { setBusy(false); }
  }
  return (
    <form className="task-quick-add" onSubmit={submit}>
      <AwField id={`quick-add-${Math.random().toString(36).slice(2)}`} label="" placeholder={placeholder} value={value} onChange={event => setValue(event.target.value)}/>
      <AwButton type="submit" variant="secondary" disabled={busy || !value.trim()}>Add</AwButton>
    </form>
  );
}
